import { render, staticRenderFns } from "./informed-consent.vue?vue&type=template&id=cdf4cb46&scoped=true&"
import script from "./informed-consent.vue?vue&type=script&lang=js&"
export * from "./informed-consent.vue?vue&type=script&lang=js&"
import style0 from "./informed-consent.vue?vue&type=style&index=0&id=cdf4cb46&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdf4cb46",
  null
  
)

export default component.exports